module.exports = __webpack_public_path__ + "img/home.efdae680.png";